import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../types";
import { axiosClient } from "../../../api/axios-client";
import { sendMessageLogSubmission } from "./send-message-log";
import VurbalizeEvents from "../../../types/dto/chat/vurbalize-events";
import getMessageByVurablizeEvent from "../../../../application/utils/get-message-by-vurablize-event";
import { setGetFeedback } from "../chat-slice";
import getCommonData from "../../../../application/utils/get-common-data";

export const sendFeedbackForm = createAsyncThunk<
  void,
  { feedbacktext: string, feedback: string, }
>(
  "chat-slice/send-feedback-form",
  async (
    formData,
    { getState, signal, dispatch }
  ) => {
    const state = getState() as RootState;
    const appState = state["app-state"];
    
    const reqBody = {
      ...getCommonData(appState),
      form_data: formData
    };

    dispatch(setGetFeedback(false));

    dispatch(sendMessageLogSubmission({
      data: {
        message: getMessageByVurablizeEvent(VurbalizeEvents.FEEDBACK_SUBMITTED),
        event_name: VurbalizeEvents.FEEDBACK_SUBMITTED,
        feedback_text: formData.feedbacktext,
        feedback_rating: formData.feedback,
      }
    }))

    const response = await axiosClient.post(
      "/feedback_data",
      reqBody, {
        signal
      }
    );
  }
);
